import { render, staticRenderFns } from "./SalesSelect.vue?vue&type=template&id=686d7442&"
import script from "./SalesSelect.vue?vue&type=script&lang=js&"
export * from "./SalesSelect.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "SalesSelect.vue"
export default component.exports